import { applyFileBrowserActivityFromMain } from '../../../files/browser/in-flight.js';
import {
  deferBackgroundSymbolIndexTasks,
  enqueueSymbolIndexTaskInternal,
  markLatestActiveSymbolIndexTaskInternal,
} from '../scheduler/task-queue-core.js';
import { kickSymbolIndexWorkerLoop } from '../scheduler/task-queue-worker.js';
import type { SymbolIndexWorkerInMessage } from './protocol.js';

export function handleQueueWorkerMessage(msg: SymbolIndexWorkerInMessage): void {
  switch (msg.type) {
    case 'enqueue':
      if (enqueueSymbolIndexTaskInternal(msg.parentPath, msg.filePath, msg.priority, msg.sequence)) {
        kickSymbolIndexWorkerLoop();
      }
      return;
    case 'markLatestActive':
      markLatestActiveSymbolIndexTaskInternal(msg.parentPath, msg.sequence);
      return;
    case 'deferBackground':
      deferBackgroundSymbolIndexTasks();
      return;
    case 'fileBrowserActivity':
      applyFileBrowserActivityFromMain({
        inFlightRequests: msg.inFlightRequests,
        inFlightReads: msg.inFlightReads,
        lastActivityAt: msg.lastActivityAt,
      });
      return;
    default:
      return;
  }
}
